import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,_vm._g(_vm._b({on:{"click":(v) => _vm.$emit('click', v)}},'v-chip',_vm.$attrs,false),_vm.$listeners),[(_vm.leftIcon)?_c(VIcon,{staticClass:"left-icon"},[_vm._v(_vm._s(_vm.leftIcon))]):_vm._e(),_c('p',{staticClass:"subtitle-2"},[_vm._t("default")],2),(_vm.rightIcon)?_c(VIcon,{staticClass:"right-icon"},[_vm._v(_vm._s(_vm.rightIcon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }